import {
	ANNOUNCE_DELETE_REQUEST,
	ANNOUNCE_DELETE_SUCCESS,
	ANNOUNCE_DELETE_FAILURE
} from '../../../constants';

const initialState = {
	data: null,
	loading: false,
	error: null,
	type: null,
};

const deleteAppReducer = (state = initialState, action) => {
	switch (action.type) {
		case ANNOUNCE_DELETE_REQUEST:
			return {
				...state,
				loading: true,
				data: null,
				error: null,
				type: null,
			};
		case ANNOUNCE_DELETE_SUCCESS:
			return {
				...state,
				loading: false,
				data: action.payload,
				type: action.types,
				error: null,
			};
		case ANNOUNCE_DELETE_FAILURE:
			return {
				...state,
				loading: false,
				error: action.payload,
				type: action.types,
				data: null,
			};
		default:
			return state;
	}
};

export default deleteAppReducer;
